import * as React from "react";
import RaffleAiWidget from "./RaffleAiWidget";
import { useRaffleAiConfig } from "./use-raffle-ai-config";

interface RaffleAiContainerProps {
  productCode?: string;
}

const RaffleAiContainer: React.FC<RaffleAiContainerProps> = ({
  productCode
}) => {
  const config = useRaffleAiConfig();

  // Don't render widget if config is not available
  if (!config) {
    return null;
  }

  return <RaffleAiWidget {...config} productCode={productCode} />;
};

export default RaffleAiContainer;
